module.exports = __webpack_public_path__ + "media/components/Sponsors/Layouts/SideMenu/scoutIcon-91d388b6dd911a55436b3290833dfc6f.svg";